export const MEMBER_TYPE = {
  USER: 1,
  ADVISER: 2,
  COMPANY: 3,
  ADMINISTRATOR: 4,
}

export const MEMBER_TYPE_STRING = {
  USER: "user",
  ADVISER: "adviser",
  COMPANY: "company",
  ADMINISTRATOR: "admin",
}

export const MEMBER_TYPE_STRING_CAPITAL = {
  USER: "MEMBER",
  ADVISER: "ADVISER",
  COMPANY: "COMPANY",
  ADMINISTRATOR: "ADMIN",
}

export const RESPONSE_CODE = {
  SUCCESS: 200,
  CREATE_SUCCESS: 201,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_APPROVED: 406,
  CONFLICT: 409,
}

export const GENDER = {
  MALE: "MALE",
  FEMALE: "FEMALE",
}

export const USER_ATTRIBITE_KEY = {
  AWS_ID: "sub",
  VERIFIED: "email_verified",
  USER_TYPE: "custom:UserType",
  EMAIL: "email",
}

export const QUALIFICATION_TYPE = {
  COORDINATOR: "COORDINATOR",
  CHIEF_COORDINATOR: "CHIEFCOORDINATOR",
}

export const STORAGE_KEY = {
  MASTER_DATA: "master_data",
  TOKEN: "token",
  LOGIN: "login",
  USER_TYPE: "type",
  AWS_ID: "aws_id",
  TEMP_USER_TYPE: "temp_user_type",
}

export const EVENT_CATEGORY = {
  SEMINAR: 1,
  TALK_EVENT: 2,
  DEMO: 3,
  MEET_UP: 4,
  ADVISER: 5,
  EXPLAIN: 6,
  EXCHANGE: 7,
  ETC: 8,
}

export const EVENT_STATUS = {
  RECEIVING: "RECEIVING",
  STARTED: "STARTED",
  ARCHIVED: "ARCHIVED",
  CANCELLED: "CANCELED",
  DRAFT: "DRAFT",
}

export const APPLICATION_STATUS = {
  RESERVED: "RESERVED",
  CANCELLED: "CANCELED",
}

export const EVENT_TYPE = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  BOTH: "BOTH",
}

export const JOIN_TYPE = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
}

export const SNACKBAR_TYPES = {
  SUCCESS: 1,
  WARNING: 2,
  INFORMATION: 3,
  ERROR: 4,
}

export const NEWS_INTERVIEW_TYPES_STRING = {
  NEWS: "NEWS",
  INTERVIEW: "INTERVIEW",
}

export const NEWS_STATE = {
  CREATE: 1,
  EDIT: 2,
}

export const NEWS_MODAL_TYPE = {
  PUBLISH: 1,
  DELETE: 2,
  PRIVATE: 3,
  DRAFT: 4,
  SAVE: 5,
}

export const EVENT_MODAL_TYPE = {
  PUBLIC: 1,
  REMOVE: 2,
  ARCHIVE: 3,
}

export const MENU_TYPE = {
  INBOX: 1,
  FAVORITE_VIDEO: 2,
  REGISTER_INFORMATION: 3,
  CONTACT: 4,
  CONSULT_MANAGE: 5,
  EVENT_MANAGE: 6,
  NEWS_MANAGE: 7,
  USER_MANAGE: 8,
  BOOK_LIBRARY_MANAGE: 9,
}

export const SUB_MENU_TYPE = {
  // INBOX_ALL: 1,
  INBOX_CONSULT: 2,
  INBOX_EVENT: 3,
  INBOX_CONTACT: 4,
  REGISTER_INFO_CHANGE: 5,
  REGISTER_PASS_CHANGE: 6,
  EVENT_LIST: 7,
  EVENT_CREATE: 8,
  EVENT_EDIT: 9,
  EVENT_LIST_RECEIVING: 10,
  EVENT_LIST_STARTED: 11,
  EVENT_LIST_ARCHIVED: 12,
  NEWS_CREATE: 13,
  NEWS_ALL: 14,
  NEWS_NEWS: 15,
  NEWS_INTERVIEW: 16,
  USER_MEMBER: 17,
  USER_ADVISER: 18,
  USER_COMPANY: 19,
  USER_ADMIN: 20,
  USER_LIST: 21,
  INVITE_USER: 22,
  ADVISER_LIST: 23,
  COMPANY_LIST: 24,
  ADMINISTRATOR_LIST: 25,
  CONSULT_LIST: 26,
  CONSULT_RESERVATION: 27,
  CONSULT_ACCEPTED: 28,
  CONSULT_CANCEL: 29,
  CONSULT_RESIGNED: 30,
  BOOKS_LIST: 31,
  BOOKS_CREATE: 32,
  EVENT_LIST_DRAFT: 33,
}

export const ADVISE_TYPE = {
  MEETING: "MEETING",
  CALL: "CALL",
  ONLINE: "ONLINE",
}

export const CONSULT_STATUS = {
  RESERVED: "RESERVED",
  ACCEPTED: "ACCEPTED",
  FINISHED: "FINISHED",
  RESIGNED: "RESIGNED",
  CANCELED: "CANCELED",
}

export const SELECT_OTHER = 4

export const SORT_ORDER = {
  ASCENDING: "ASC",
  DESCENDONG: "DESC",
}

export const MEMBER_STATUS = {
  REQUEST: "REQUESTED",
  ACCEPTED: "ACCEPTED",
}

export const PROVINCES = [
  {
    label: "北海道",
    value: "北海道",
  },
  {
    label: "青森県",
    value: "青森県",
  },
  {
    label: "岩手県",
    value: "岩手県",
  },
  {
    label: "宮城県",
    value: "宮城県",
  },
  {
    label: "秋田県",
    value: "秋田県",
  },
  {
    label: "山形県",
    value: "山形県",
  },
  {
    label: "福島県",
    value: "福島県",
  },
  {
    label: "茨城県",
    value: "茨城県",
  },
  {
    label: "栃木県",
    value: "栃木県",
  },
  {
    label: "群馬県",
    value: "群馬県",
  },
  {
    label: "埼玉県",
    value: "埼玉県",
  },
  {
    label: "千葉県",
    value: "千葉県",
  },
  {
    label: "東京都",
    value: "東京都",
  },
  {
    label: "神奈川県",
    value: "神奈川県",
  },
  {
    label: "新潟県",
    value: "新潟県",
  },
  {
    label: "富山県",
    value: "富山県",
  },
  {
    label: "石川県",
    value: "石川県",
  },
  {
    label: "福井県",
    value: "福井県",
  },
  {
    label: "山梨県",
    value: "山梨県",
  },
  {
    label: "長野県",
    value: "長野県",
  },
  {
    label: "岐阜県",
    value: "岐阜県",
  },
  {
    label: "静岡県",
    value: "静岡県",
  },
  {
    label: "愛知県",
    value: "愛知県",
  },
  {
    label: "三重県",
    value: "三重県",
  },
  {
    label: "滋賀県",
    value: "滋賀県",
  },
  {
    label: "京都府",
    value: "京都府",
  },
  {
    label: "大阪府",
    value: "大阪府",
  },
  {
    label: "兵庫県",
    value: "兵庫県",
  },
  {
    label: "奈良県",
    value: "奈良県",
  },
  {
    label: "和歌山県",
    value: "和歌山県",
  },
  {
    label: "鳥取県",
    value: "鳥取県",
  },
  {
    label: "島根県",
    value: "島根県",
  },
  {
    label: "岡山県",
    value: "岡山県",
  },
  {
    label: "広島県",
    value: "広島県",
  },
  {
    label: "山口県",
    value: "山口県",
  },
  {
    label: "徳島県",
    value: "徳島県",
  },
  {
    label: "香川県",
    value: "香川県",
  },
  {
    label: "愛媛県",
    value: "愛媛県",
  },
  {
    label: "高知県",
    value: "高知県",
  },
  {
    label: "福岡県",
    value: "福岡県",
  },
  {
    label: "佐賀県",
    value: "佐賀県",
  },
  {
    label: "長崎県",
    value: "長崎県",
  },
  {
    label: "熊本県",
    value: "熊本県",
  },
  {
    label: "大分県",
    value: "大分県",
  },
  {
    label: "宮崎県",
    value: "宮崎県",
  },
  {
    label: "鹿児島県",
    value: "鹿児島県",
  },
  {
    label: "沖縄県",
    value: "沖縄県",
  },
]

export const COUNTRIES = [
  "アイスランド",
  "アイルランド",
  "アゼルバイジャン",
  "アフガニスタン",
  "アブハジア",
  "アメリカ",
  "アラブ首長国連邦",
  "アルジェリア",
  "アルゼンチン",
  "アルバニア",
  "アルメニア",
  "アンゴラ",
  "アンティグア・バーブーダ",
  "アンドラ",
  "イエメン",
  "イギリス",
  "イスラエル",
  "イタリア",
  "イラク",
  "イラン",
  "インド",
  "インドネシア",
  "ウガンダ",
  "ウクライナ",
  "ウズベキスタン",
  "ウルグアイ",
  "エクアドル",
  "エジプト",
  "エストニア",
  "エチオピア",
  "エリトリア",
  "エルサルバドル",
  "沿ドニエストル",
  "オーストラリア",
  "オーストリア",
  "オマーン",
  "オランダ",
  "ガーナ",
  "カーボベルデ",
  "ガイアナ",
  "カザフスタン",
  "カタール",
  "カナダ",
  "ガボン",
  "カメルーン",
  "韓国",
  "ガンビア",
  "カンボジア",
  "北キプロス",
  "北朝鮮",
  "ギニア",
  "ギニアビサウ",
  "キプロス",
  "キューバ",
  "ギリシャ",
  "キリバス",
  "キルギス",
  "グアテマラ",
  "クウェート",
  "クック諸島",
  "グレナダ",
  "クロアチア",
  "ケニア",
  "コートジボワール",
  "コスタリカ",
  "コソボ",
  "コモロ",
  "コロンビア",
  "コンゴ共和国",
  "コンゴ民主共和国",
  "サウジアラビア",
  "サモア",
  "サントメ・プリンシペ",
  "ザンビア",
  "サンマリノ",
  "シエラレオネ",
  "ジブチ",
  "ジャマイカ",
  "ジョージア",
  "シリア",
  "シンガポール",
  "ジンバブエ",
  "スイス",
  "スウェーデン",
  "スーダン",
  "スペイン",
  "スリナム",
  "スリランカ",
  "スロバキア",
  "スロベニア",
  "スワジランド",
  "セーシェル",
  "赤道ギニア",
  "セネガル",
  "セルビア",
  "セントクリストファー・ネイビス",
  "セントビンセントおよびグレナディーン諸島",
  "セントルシア",
  "ソマリア",
  "ソマリランド",
  "ソロモン諸島",
  "タイ",
  "台湾",
  "タジキスタン",
  "タンザニア",
  "チェコ",
  "チャド",
  "中央アフリカ共和国",
  "中国",
  "チュニジア",
  "チリ",
  "ツバル",
  "デンマーク",
  "ドイツ",
  "トーゴ",
  "ドミニカ共和国",
  "ドミニカ国",
  "トリニダード・トバゴ",
  "トルクメニスタン",
  "トルコ",
  "トンガ",
  "ナイジェリア",
  "ナウル",
  "ナゴルノ・カラバフ",
  "ナミビア",
  "ニウエ",
  "ニカラグア",
  "ニジェール",
  "西サハラ",
  "日本",
  "ニュージーランド",
  "ネパール",
  "ノルウェー",
  "バーレーン",
  "ハイチ",
  "パキスタン",
  "バチカン",
  "パナマ",
  "バヌアツ",
  "バハマ",
  "パプアニューギニア",
  "パラオ",
  "パラグアイ",
  "バルバドス",
  "パレスチナ",
  "ハンガリー",
  "バングラデシュ",
  "東ティモール",
  "フィジー",
  "フィリピン",
  "フィンランド",
  "ブータン",
  "ブラジル",
  "フランス",
  "ブルガリア",
  "ブルキナファソ",
  "ブルネイ",
  "ブルンジ",
  "ベトナム",
  "ベナン",
  "ベネズエラ",
  "ベラルーシ",
  "ベリーズ",
  "ペルー",
  "ベルギー",
  "ポーランド",
  "ボスニア・ヘルツェゴビナ",
  "ボツワナ",
  "ボリビア",
  "ポルトガル",
  "ホンジュラス",
  "マケドニア旧ユーゴスラビア共和国",
  "マーシャル諸島",
  "マダガスカル",
  "マラウイ",
  "マリ",
  "マルタ",
  "マレーシア",
  "ミクロネシア連邦",
  "南アフリカ",
  "南オセチア",
  "南スーダン",
  "ミャンマー",
  "メキシコ",
  "モーリシャス",
  "モーリタニア",
  "モザンビーク",
  "モナコ",
  "モルディブ",
  "モルドバ",
  "モロッコ",
  "モンゴル",
  "モンテネグロ",
  "ヨルダン",
  "ラオス",
  "ラトビア",
  "リトアニア",
  "リビア",
  "リヒテンシュタイン",
  "リベリア",
  "ルーマニア",
  "ルクセンブルク",
  "ルワンダ",
  "レソト",
  "レバノン",
  "ロシア",
]
